import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Platform from "@/pages/Platform";
import Navbar from "@/components/Navbar";
import { Toaster } from "@/components/ui/sonner";
import "@/index.css";

function App() {
  return (
    <BrowserRouter>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/platform" element={<Platform />} />
      </Routes>
      <Toaster />
    </BrowserRouter>
  );
}

export default App;
